import React, { useEffect, useState } from 'react'
import { updateCancellation, viewCancellation } from "../../../Context/api";
import { policyAddValidation } from '../../../Context/validation';
import axios from "axios";
import { commonMessage, statusCodes } from "../../../Constants/generalConfig";
import Spinner from '../../Spinner/spinner';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from 'formik';


const EditPolicy = () => {
    const [spinner, setSpinner] = useState(false)
    const { id } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        getPolicy()
    }, [])
    const getPolicy = () => {
        setSpinner(true)
        axios.post(viewCancellation(), { cancellationId: id },).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setSpinner(false)
                policyEdit.setValues(resp.data.data)
            }
            else {
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })

    };
    const policyEdit = useFormik({
        initialValues: {
            refundType: '',
            validity: '',
            days: '',
            cancellationCharge: ''
        },
        validationSchema: policyAddValidation,
        onSubmit: (values) => {
            const data = {
                refundType: values.refundType,
                validity: values.validity,
                days: values.days,
                cancellationCharge: values.cancellationCharge,
                cancellationId:id
            }
            axios.post(updateCancellation(), data).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    setSpinner(false)
                    setTimeout(() => {
                        navigate(-1)
                    }, 1000);
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                    setSpinner(false)
                })
        }
    })
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Edit Policy
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={policyEdit.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Refund Type *</label>
                            <select className='form-select' name='refundType'
                                onChange={policyEdit.handleChange}
                                value={policyEdit.values.refundType}>
                                <option value="" hidden>Select</option>
                                <option value="FULL">Full</option>
                                <option value="PARTIAL">Partial</option>
                            </select>
                            {policyEdit.touched.refundType && policyEdit.errors.refundType ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {policyEdit.errors.refundType}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Validity *</label>
                            <select className='form-select' name='validity'
                                onChange={policyEdit.handleChange}
                                value={policyEdit.values.validity}>
                                <option value="" hidden>Select</option>
                                <option value="MONTHLY">Monthly</option>
                                <option value="YEARLY">Yearly</option>
                            </select>
                            {policyEdit.touched.validity && policyEdit.errors.validity ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {policyEdit.errors.validity}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Days *</label>
                            <input type="number" className="form-control"
                                id="recipient-name"
                                maxLength={10}
                                name='days'
                                onChange={policyEdit.handleChange}
                                value={policyEdit.values.days}
                                onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}

                            />
                            {policyEdit.touched.days && policyEdit.errors.days ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {policyEdit.errors.days}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Charges (%)*</label>
                            <input type="number" className="form-control"
                                id="recipient-name"
                                maxLength={10}
                                name='cancellationCharge'
                                onChange={policyEdit.handleChange}
                                value={policyEdit.values.cancellationCharge}
                                onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}

                            />
                            {policyEdit.touched.cancellationCharge && policyEdit.errors.cancellationCharge ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {policyEdit.errors.cancellationCharge}
                                </div>
                            ) : null}
                        </div>
                        <div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>



            </section>
        </>
    )
}

export default EditPolicy